import request from '@/plugins/request';

/**
 * 获取动态菜单
 * @param data
 * @returns {*}
 * @constructor
 */
export function MenuList(data) {
  return request({
    url: '/system/menu/getClientMenu',
    method: 'get'
  });
}

/**
 * 获取动态路由
 * @param data
 * @returns {*}
 * @constructor
 */
export function RouterList(data) {
  return request({
    url: '/system/menu/getClientRouter',
    method: 'get'
  });
}

/**
 * 保存菜单
 * @param data
 * @returns {*}
 */
export function saveMenu(data) {
  return request({
    url: '/system/menu/save',
    method: 'post',
    data: data
  });
}

/**
 * 获取菜单列表（展示）
 * @returns {*}
 */
export function getMenuList() {
  return request({
    url: '/system/menu/getMenuList',
    method: 'get'
  });
}

/**
 * 删除菜单
 * @returns {*}
 */
export function deleteMenu() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return request({
    url: '/system/menu/delete',
    method: 'post',
    data: {
      idList: data
    }
  });
}

/**
 * 获取菜单按钮列表
 * @returns {*}
 */
export function getMenuButtons(menuId) {
  return request({
    url: "/system/menu/getMenuButtons/".concat(menuId),
    method: 'get'
  });
}